import AppSettingController from "../../../Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";

export default function ToggleShowQrcode() {
    const {t} = useTranslation();
    const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;

    if (setting.service !== "netbee") return null;

    return (
        <section>
            <div className={"dark-mode"}>
                <p>{t("setting.showQrCode")}</p>
                <div className={"dark-mode-toggle"}>
                    <label className="switch">
                        <input type="checkbox"
                               checked={setting.showQrCode}
                               onChange={() => AppSettingController.toggleShowQrCode()}/>
                        <span className="slider round"></span>
                    </label>
                </div>
            </div>
        </section>
    )
}